import type { WithGridElementAttentionStatus } from '../../evaluation/AttentionStatus';
import type {
  ForProvidingAttentionStatus,
  ForProvidingAttentionStatus2
} from '../../evaluation/AttentionStatusRepository';
import {
  AttentionStatusProvider,
  AttentionStatusProvider2
} from '../../evaluation/AttentionStatusRepository';
import type { CalculationState } from '../../index';
import type {
  GridElementLoadFlowDetails,
  GridElementsLoadFlowDetails
} from '../gridElementsDetailsByCalculationType/loadFlow/gridElementLoadFlowDetails.types';
import type {
  GridElementShortCircuitDetails,
  GridElementsShortCircuitDetails
} from '../gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitDetails';
import { GridElements } from './GridElements';

export const evaluatedGridElements = (
  state: CalculationState
): CalculationState['gridElementDetails'] => {
  if (
    state.calculationTactic.current !== 'LOADED' ||
    state.calculationTactic.value.status === 'Failed' ||
    state.gridElementsDetailsByCalculationType.type === 'NO_EVALUATION' ||
    state.gridElementsAttentionStatuses.type === 'NOT_AVAILABLE'
  ) {
    return { type: 'NO_EVALUATION' };
  }

  const loadFlowElementsWithStatus = getLoadFlowElementsWithStatus(
    state.gridElementsDetailsByCalculationType.gridElementsDetails.loadFlow,
    AttentionStatusProvider.createFromState(
      state.gridElementsAttentionStatuses.byCalculationType.loadFlow
    )
  );

  const shortCircuitElementsWithStatus = getShortCircuitElementsWithStatus(
    state.gridElementsDetailsByCalculationType.gridElementsDetails.shortCircuit,
    AttentionStatusProvider2.createFromState(
      state.gridElementsAttentionStatuses.byCalculationType.shortCircuit
    )
  );

  const mapElements = GridElements.fromAllCalculationTypes(
    shortCircuitElementsWithStatus,
    loadFlowElementsWithStatus
  );

  return {
    type: 'EVALUATED',
    elements: mapElements.toArray()
  };
};

function getLoadFlowElementsWithStatus(
  gridElements: GridElementsLoadFlowDetails,
  statusRepository: ForProvidingAttentionStatus
): WithGridElementAttentionStatus<GridElementLoadFlowDetails>[] {
  return gridElements.map(gridElement => ({
    ...gridElement,
    status: statusRepository.getByGridElement(gridElement.id)
  }));
}

function getShortCircuitElementsWithStatus(
  gridElements: GridElementsShortCircuitDetails,
  statusRepository: ForProvidingAttentionStatus2
): WithGridElementAttentionStatus<GridElementShortCircuitDetails>[] {
  return gridElements.map(gridElement => ({
    ...gridElement,
    status: statusRepository.getByGridElement(gridElement.id)
  }));
}
